var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFedexTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "31px",
    viewBox: "0 0 48 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0001 0.637 48 0.637 48 31 0.0001 31"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "snoo_rental",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hbi_rental_acc_overview_order_placed",
    transform: "translate(-697.000000, -269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(191.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(237.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(235.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(34.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6202,1.7515 L4.7602,1.7515 C4.3172,1.7515 3.9582,2.1105 3.9582,2.5535 L3.9582,19.3885 L6.3632,19.3885 C7.2482,19.3885 7.9662,20.1055 7.9662,20.9915 C7.9662,21.8765 7.2482,22.5945 6.3632,22.5945 L3.9582,22.5945 L3.9582,25.0005 C3.9582,25.4425 4.3172,25.8015 4.7602,25.8015 L34.4222,25.8015 L34.4222,2.5535 C34.4222,2.1105 34.0622,1.7515 33.6202,1.7515",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0421,14.5781 L34.4221,14.5781 L34.4221,25.8021 L47.2491,25.8021 L47.2491,17.7851 C47.2491,16.0141 45.8131,14.5781 44.0421,14.5781",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.422,16.9834 L43.107,16.9834 C43.992,16.9834 44.71,17.7014 44.71,18.5864 L44.71,25.8014 L34.422,25.8014 L34.422,16.9834 Z",
    id: "Fill-5",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8351,4.9585 L34.4221,4.9585 L34.4221,8.1655 L43.2401,8.1655 L43.2401,7.3635 C43.2401,6.0355 42.1631,4.9585 40.8351,4.9585",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#E1E1E1",
    points: "44.0421 14.5781 42.4381 8.1651 34.4221 8.1651 34.4221 14.5781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0421,17.7852 L47.2491,17.7852 L47.2491,20.9922 L45.6451,20.9922 C44.7601,20.9922 44.0421,20.2742 44.0421,19.3882 L44.0421,17.7852 Z",
    id: "Fill-11",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0333,20.1899 C37.6173,20.1899 35.5153,21.5269 34.4223,23.5009 L34.4223,25.8019 L46.3913,25.8019 C45.9963,22.6389 43.3033,20.1899 40.0333,20.1899",
    id: "Fill-13",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7101,22.2202 L44.7101,25.8022 L46.3911,25.8022 C46.2191,24.4252 45.6111,23.1832 44.7101,22.2202",
    id: "Fill-15",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0333,22.5952 C42.2473,22.5952 44.0423,24.3892 44.0423,26.6032 C44.0423,28.8172 42.2473,30.6122 40.0333,30.6122 C37.8203,30.6122 36.0253,28.8172 36.0253,26.6032 C36.0253,24.3892 37.8203,22.5952 40.0333,22.5952",
    id: "Fill-17",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6285,10.5698 L43.0395,10.5698 L42.4385,8.1648 L34.4215,8.1648 L34.4215,14.5778 L36.8265,14.5778 L36.8265,11.3718 C36.8265,10.9288 37.1855,10.5698 37.6285,10.5698",
    id: "Fill-19",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5782,20.1899 C11.5542,20.1899 9.7512,21.1299 8.5762,22.5949 L6.3632,22.5949 L3.9582,22.5949 L3.9582,24.9999 C3.9582,25.4429 4.3172,25.8019 4.7602,25.8019 L34.4222,25.8019 L34.4222,22.5949 L18.5802,22.5949 C17.4052,21.1299 15.6022,20.1899 13.5782,20.1899",
    id: "Fill-21",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5782,22.5952 C15.7922,22.5952 17.5862,24.3892 17.5862,26.6032 C17.5862,28.8172 15.7922,30.6122 13.5782,30.6122 C11.3642,30.6122 9.5702,28.8172 9.5702,26.6032 C9.5702,24.3892 11.3642,22.5952 13.5782,22.5952",
    id: "Fill-23",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(0.000000, 0.363200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6451,19.877 C45.1751,19.877 44.7931,19.495 44.7931,19.025 L44.7931,18.173 L46.4971,18.173 L46.4971,19.877 L45.6451,19.877 Z M40.0331,29.497 C38.2381,29.497 36.7761,28.036 36.7761,26.24 C36.7761,24.444 38.2381,22.983 40.0331,22.983 C41.8291,22.983 43.2901,24.444 43.2901,26.24 C43.2901,28.036 41.8291,29.497 40.0331,29.497 L40.0331,29.497 Z M13.5781,29.497 C11.7821,29.497 10.3211,28.036 10.3211,26.24 C10.3211,24.444 11.7821,22.983 13.5781,22.983 C15.3741,22.983 16.8351,24.444 16.8351,26.24 C16.8351,28.036 15.3741,29.497 13.5781,29.497 L13.5781,29.497 Z M40.8351,5.347 C41.7471,5.347 42.4881,6.088 42.4881,7 L42.4881,7.05 L35.1731,7.05 L35.1731,5.347 L40.8351,5.347 Z M35.1731,8.553 L41.8521,8.553 L43.0791,13.463 L35.1731,13.463 L35.1731,8.553 Z M44.6401,13.509 L43.3971,8.537 C43.7371,8.464 43.9921,8.163 43.9921,7.802 L43.9921,7 C43.9921,5.259 42.5761,3.843 40.8351,3.843 L35.1731,3.843 L35.1731,2.19 C35.1731,1.334 34.4771,0.637 33.6201,0.637 L4.7601,0.637 C3.9031,0.637 3.2071,1.334 3.2071,2.19 L3.2071,15.818 C3.2071,16.233 3.5431,16.57 3.9581,16.57 C4.3731,16.57 4.7101,16.233 4.7101,15.818 L4.7101,2.19 C4.7101,2.162 4.7321,2.14 4.7601,2.14 L33.6201,2.14 C33.6471,2.14 33.6701,2.162 33.6701,2.19 L33.6701,15.818 C33.6701,16.233 34.0061,16.57 34.4211,16.57 C34.8361,16.57 35.1731,16.234 35.1731,15.818 L35.1731,14.967 L44.0391,14.967 L44.0411,14.967 L44.0431,14.967 C45.1341,14.967 46.0611,15.684 46.3781,16.67 L44.0411,16.67 C43.6261,16.67 43.2901,17.007 43.2901,17.422 L43.2901,19.025 C43.2901,20.324 44.3461,21.38 45.6451,21.38 L46.4971,21.38 L46.4971,24.687 L44.5321,24.687 C43.8861,22.823 42.1141,21.48 40.0331,21.48 C37.9531,21.48 36.1801,22.823 35.5351,24.687 L35.1731,24.687 L35.1731,19.025 C35.1731,18.61 34.8361,18.273 34.4211,18.273 C34.0061,18.273 33.6701,18.61 33.6701,19.025 L33.6701,24.687 L18.0771,24.687 C17.4311,22.823 15.6591,21.48 13.5781,21.48 C11.4981,21.48 9.7261,22.823 9.0801,24.687 L4.7601,24.687 C4.7321,24.687 4.7101,24.665 4.7101,24.637 L4.7101,22.983 L7.9661,22.983 C8.3811,22.983 8.7181,22.647 8.7181,22.231 C8.7181,21.816 8.3821,21.48 7.9661,21.48 L0.7511,21.48 C0.3361,21.48 0.0001,21.816 0.0001,22.231 C0.0001,22.647 0.3361,22.983 0.7511,22.983 L3.2071,22.983 L3.2071,24.637 C3.2071,25.493 3.9031,26.19 4.7601,26.19 L8.8201,26.19 C8.8191,26.207 8.8181,26.223 8.8181,26.24 C8.8181,28.865 10.9541,31 13.5781,31 C16.2031,31 18.3381,28.865 18.3381,26.24 C18.3381,26.223 18.3371,26.207 18.3371,26.19 L35.2741,26.19 C35.2741,26.207 35.2731,26.223 35.2731,26.24 C35.2731,28.865 37.4091,31 40.0331,31 C42.6581,31 44.7931,28.865 44.7931,26.24 C44.7931,26.223 44.7921,26.207 44.7921,26.19 L47.2491,26.19 C47.6641,26.19 48.0001,25.854 48.0001,25.439 L48.0001,17.421 C48.0001,15.442 46.5401,13.798 44.6401,13.509 L44.6401,13.509 Z",
    id: "Fill-25",
    fill: "#6B6B6B",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.5782,25.0503 C12.7222,25.0503 12.0252,25.7473 12.0252,26.6033 C12.0252,27.4603 12.7222,28.1563 13.5782,28.1563 C14.4342,28.1563 15.1312,27.4603 15.1312,26.6033 C15.1312,25.7473 14.4342,25.0503 13.5782,25.0503",
    id: "Fill-28",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0333,25.0503 C39.1773,25.0503 38.4803,25.7473 38.4803,26.6033 C38.4803,27.4603 39.1773,28.1563 40.0333,28.1563 C40.8893,28.1563 41.5863,27.4603 41.5863,26.6033 C41.5863,25.7473 40.8893,25.0503 40.0333,25.0503",
    id: "Fill-30",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2403,22.5952 C19.2403,23.0102 19.5763,23.3462 19.9913,23.3462 L31.2153,23.3462 C31.6303,23.3462 31.9673,23.0102 31.9673,22.5952 C31.9673,22.1802 31.6303,21.8432 31.2153,21.8432 L19.9913,21.8432 C19.5763,21.8432 19.2403,22.1802 19.2403,22.5952",
    id: "Fill-32",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3551,20.1401 L11.9751,20.1401 C12.3901,20.1401 12.7271,19.8031 12.7271,19.3881 C12.7271,18.9731 12.3901,18.6371 11.9751,18.6371 L2.3551,18.6371 C1.9401,18.6371 1.6031,18.9731 1.6031,19.3881 C1.6031,19.8031 1.9401,20.1401 2.3551,20.1401",
    id: "Fill-34",
    fill: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3912,9.7642 L8.4622,9.7642 C7.4352,9.7642 6.6022,8.9312 6.6022,7.9042 L6.6022,6.2182 C6.6022,5.1912 7.4352,4.3582 8.4622,4.3582 L13.3912,4.3582 C14.4182,4.3582 15.2512,5.1912 15.2512,6.2182 L15.2512,7.9042 C15.2512,8.9312 14.4182,9.7642 13.3912,9.7642",
    id: "Fill-36",
    fill: "#535353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7506,9.7642 L18.0646,9.7642 C17.0376,9.7642 16.2056,8.9312 16.2056,7.9042 L16.2056,6.2182 C16.2056,5.1912 17.0376,4.3582 18.0646,4.3582 L19.7506,4.3582 C20.7776,4.3582 21.6106,5.1912 21.6106,6.2182 L21.6106,7.9042 C21.6106,8.9312 20.7776,9.7642 19.7506,9.7642",
    id: "Fill-38",
    fill: "#A5A5A5"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedexTruck);
export default __webpack_public_path__ + "static/media/fedex-truck.ddad4ac23afae1da4a284d52103dc2e4.svg";
export { ForwardRef as ReactComponent };